"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useWebSession = void 0;
const web_blizzard_reporting_1 = require("@snapchat/web-blizzard-reporting");
const react_1 = require("react");
function useWebSession(pageType, webVitalsRef, webClientId = "") {
    (0, react_1.useEffect)(() => {
        // bail if we don't have a webClientId yet
        if (!webClientId)
            return;
        // flag to avoid a race condition between visibilitychange and pageHide event
        // this is so we don't double report a web session
        let sessionReported = false;
        addEventListener("visibilitychange", () => {
            if (document.visibilityState === "hidden" && !sessionReported) {
                sessionReported = true;
                reportWebSessionWithWebVitals(pageType, webVitalsRef, webClientId);
            }
        });
        // pageHide is a more consistent browser event than visibilityChange for ios Safari
        addEventListener("pageHide", () => {
            if (!sessionReported) {
                sessionReported = true;
                reportWebSessionWithWebVitals(pageType, webVitalsRef, webClientId);
            }
        });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [webClientId]); // run with webclientid,
}
exports.useWebSession = useWebSession;
function reportWebSessionWithWebVitals(pageType, webVitalsRef, webClientId) {
    (0, web_blizzard_reporting_1.reportWebSession)({
        pageLoadTtfb: webVitalsRef.current.TTFB,
        pageLoadFcp: webVitalsRef.current.FCP,
        pageLoadCls: webVitalsRef.current.CLS,
        pageLoadFid: webVitalsRef.current.FID,
        pageLoadLcp: webVitalsRef.current.LCP,
        pageType,
        webClientId,
    });
}
//# sourceMappingURL=WebSession.js.map